'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createMediaHttpService = require('./createMediaHttpService');

var _createMediaHttpService2 = _interopRequireDefault(_createMediaHttpService);

var _createExportApi = require('./api/createExportApi');

var _createExportApi2 = _interopRequireDefault(_createExportApi);

var _createImageApi = require('./api/createImageApi');

var _createImageApi2 = _interopRequireDefault(_createImageApi);

var _createLinkApi = require('./api/createLinkApi');

var _createLinkApi2 = _interopRequireDefault(_createLinkApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (apiUrl, jwtToken) {
    var mediaHttp = (0, _createMediaHttpService2.default)(apiUrl, jwtToken);

    return {
        export: (0, _createExportApi2.default)(mediaHttp),
        image: (0, _createImageApi2.default)(mediaHttp),
        link: (0, _createLinkApi2.default)(mediaHttp)
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/common/media/mediaService/index.js
// module id = 2284
// module chunks = 0